{
  "Version": "2.94.0-fa757616",
  "VersionSimple": "2.94.0",
  "TagVersion": "v2.94.000",
  "AssemblyFileVersion": "2.94.0.0",
  "ReleaseDate": "03-11-2026",
  "Major": 2,
  "Minor": 94,
  "Env": "Dev",
  "GitCommitId": "fa7576168d9ffedfbff020d9f754478deaa16d33",
  "GitCommitIdShort": "fa757616"
}
